var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"inline-flex items-center text-sm cursor-pointer",class:[
    ("aha-link--" + _vm.variant),
    ("aha-link--" + _vm.type + "-type"),
    {
      'ml-4': _vm.hasMarginLeft,
      'mr-4': _vm.hasMarginRight,
    } ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }